import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { PropertyInterface } from '../../models/reports/report-view.model';

@Directive({
  selector: '[miqEditingBoxTarget]',
  standalone: false,
})
export class EditingBoxTargetDirective implements OnInit {
  constructor(private el: ElementRef) {}

  @Input() miqEditingBoxTarget: PropertyInterface;

  ngOnInit() {
    const { edpUpdateConf } = this.miqEditingBoxTarget;
    if (edpUpdateConf && this.el) {
      const currentClass = this.el.nativeElement.className || '';
      if (!currentClass.includes('editing-box-target')) {
        this.el.nativeElement.className = `${currentClass} editing-box-target`;
      }
    }
  }
}
